<div class="form-container service-form">
  <div #fcomNotification *ngIf="formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR">
    <fcom-notification
      aria-live="polite"
      class="pr-small-y pr-clear-t mr-clear block"
      [theme]="formStatus === FormStatus.ERROR ? NotificationTheme.ALERT : NotificationTheme.INFO"
      [iconName]="formStatus === FormStatus.ERROR ? SvgLibraryIcon.INFO : SvgLibraryIcon.CHECKMARK"
    >
      {{
        (formStatus === FormStatus.ERROR ? 'SERVICE_FORMS.serviceForms.error.title' : 'plus.profile.updateSuccess')
          | finLocalization
      }}
    </fcom-notification>
  </div>
  <span class="block pr-medium-b font-body-1 nordic-blue-900-text">{{
    'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization
  }}</span>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>
  <form [formGroup]="reactiveForm" (ngSubmit)="onSubmit()" [finFormErrorFocus]="reactiveForm">
    <ng-container *ngIf="formStatus !== FormStatus.LOADING">
      <button
        #openModalButton
        class="passport-info-help-button nordic-blue-900-text font-body-1 ms-medium-b medium-type"
        (click)="openModal($event)"
        type="button"
      >
        <span class="underline">{{ 'SERVICE_FORMS.serviceForms.fields.passportInfo.title' | finLocalization }}</span>
        <fcom-icon aria-hidden="true" class="icon-medium" [name]="SvgLibraryIcon.HELP_BLOCK"></fcom-icon>
      </button>
      <div class="flex form-subgroup">
        <fin-form-input-text
          [parentForm]="reactiveForm"
          [controlName]="PassportInformationFormFields.NUMBER"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.passportNumber'"
        ></fin-form-input-text>
      </div>
      <div class="flex flex--wrap form-subgroup">
        <fin-datepicker
          [parentForm]="reactiveForm"
          [controlName]="PassportInformationFormFields.ISSUE_DATE"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.dateOfIssue.placeHolder'"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.dateOfIssue'"
          [minDate]="expiryMinDate"
          [maxDate]="currentDate"
          [icon]="SvgLibraryIcon.CALENDAR"
        ></fin-datepicker>
        <fin-datepicker
          [parentForm]="reactiveForm"
          [controlName]="PassportInformationFormFields.EXPIRY_DATE"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.dateOfExpiry.placeHolder'"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.dateOfExpiry'"
          [icon]="SvgLibraryIcon.CALENDAR"
          [minDate]="currentDate"
          [maxDate]="expiryMaxDate"
        ></fin-datepicker>
      </div>
      <div class="flex form-subgroup">
        <fin-form-input-select
          [parentForm]="reactiveForm"
          [controlName]="PassportInformationFormFields.COUNTRY"
          [options]="countries$ | async"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.passportCountry'"
        ></fin-form-input-select>
      </div>
    </ng-container>
    <div class="ps-small-t mr-xxsmall-r align-right">
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.serviceForms.save' | finLocalization"
      ></fcom-button>
    </div>
  </form>
</div>

<fcom-modal
  [title]="'plus.profile.passportInformation' | finLocalization"
  [buttons]="ModalButtons.DONE"
  [(open)]="modalOpen"
  [fitToContent]="true"
  (close)="closeModal()"
>
  <div class="nordic-blue-900-text bold-type font-body-1 pr-small-t pr-small-l">
    {{ 'SERVICE_FORMS.serviceForms.fields.passportInfo.title' | finLocalization }}
  </div>
  <div class="pr-small">
    {{ 'SERVICE_FORMS.serviceForms.fields.passportInfo.paragraph' | finLocalization }}
  </div>
</fcom-modal>
